export default __webpack_public_path__ + "static/media/Dan Stingaciu - Development Advisor.47c2f5c1.jpg";